import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {SupplierOffersPage} from "./-page/supplier-offers.page";
import {SupplierMaterialOffersPending} from "./-page/supplier-material-offers.pending";
import {listSupplierOffersSearchSchema} from "@project/application/engineering/supplier-offers";
import {Route as SupplierRoute} from "../route";

export const Route = createFileRoute("/_app/engineering/suppliers/$supplierId/offers/")({
  component: RouteComponent,
  pendingComponent: SupplierMaterialOffersPending,
  staticData: {meta: {labelDescriptor: routeMessages.offers}},
  validateSearch: (search) => listSupplierOffersSearchSchema.parse(search),
});

function RouteComponent() {
  const {supplierId} = useParams({strict: false}) as {supplierId: string};
  const {includeDeleted} = SupplierRoute.useSearch();

  return <SupplierOffersPage supplierId={supplierId} includeDeleted={includeDeleted} />;
}
